import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { CREATE_PATIENT } from '../gqlSchemes/createPatient';
import { GET_PATIENTS } from '../gqlSchemes/getPatients';
import { useSnackbar } from 'notistack';
import { getMessageFromError } from "lib/enums/errorCodes"
import { resolveInsiError } from "components/insi/resolveInsiError"

export default function useCreatePatient(
  openNewPatientDialog,
  createSuccessDialog
) {
  const [create] = useMutation(CREATE_PATIENT);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const createPatient = (record, closeNewPatientDialog, setSubmittingFalse) => {
    create({
      variables: {
        record,
      },
      onCompleted: async (res) => {
        if (res.user.patientUser.createPatient.ok) {
          closeNewPatientDialog();
          const successResult = await createSuccessDialog.open({
            patient: res.user.patientUser.createPatient.result,
          });
          if (!successResult || !successResult.createNew) return;
          openNewPatientDialog();
        } else {
          setSubmittingFalse();
          enqueueSnackbar(resolveInsiError(res.user.patientUser.createPatient.error, t, getMessageFromError(res.user.patientUser.createPatient.error, t)), {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'center',
            },
          });
          return false;
        }
      },
      onError: (err) => {
        console.log('Error createPatient', err);
        setSubmittingFalse();
        enqueueSnackbar(err.message, {
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
          },
        });
      },
      refetchQueries: GET_PATIENTS,
    });
  };

  return { createPatient };
}
